import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const PatientRoomPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page patientRoomPage">
        <Header />
        <div className="page-header">Healthcare Dining</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Patient Room</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Provide visitors and patients with food and 
            beverage at-a-click advanced ordering for pick-up 
            at any venue on property.{'\n\n'}
            Fast, easy, mobile ordering and payment drives 
            order volume and grows F&B revenue.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Healthcare Dining - Patient Room", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default PatientRoomPage;